import { PlayerControl, OpenLink, OpenVideo, OpenMailto } from './interactive/InteractiveControls'
import { InteractiveNote } from './interactive/InteractiveNote'
import { InteractiveImage } from './interactive/InteractiveImage'
import { InteractiveHotspot } from './interactive/InteractiveHotspot'
import { InteractiveInput } from './interactive/InteractiveInput'
import { InteractivePlayeraction } from './interactive/InteractivePlayeraction'
import { InteractiveItemStyle } from './interactive/InteractiveItemStyle'

class InteractiveItem {
  constructor(data) {
    this.start = data.start;
    this.end = data.end;
    this.isActive = false;
    this.style = data.style ? new InteractiveItemStyle(data.style) : {}
    this.description = data.description;
    this.meta = data.meta ? {
      name: data.meta.name || null,
      id: data.meta.id || null
    } : {};
    switch (data.actionType) {
      case 'controlPlayer':
        this.action = new PlayerControl(data.action)
        break;
      case 'openMailto':
        this.action = new OpenMailto(data.action)
        break;
      case 'openLink':
      case 'openDownload':
        this.action = new OpenLink(data.action)
        break;
      case 'openVideo':
        this.action = new OpenVideo(data.action)
        break;
      default:
        this.action = {}
        break;
    }
    if (data && data.area && data.area.type) {
      switch (data.area.type) {
        case 'note':
          this.interactiveArea = new InteractiveNote(data.area);
          break;
        case 'hotspot':
          this.interactiveArea = new InteractiveHotspot(data.area);
          break;
        case 'image':
          this.interactiveArea = new InteractiveImage(data.area);
          break;
        case 'input':
          this.interactiveArea = new InteractiveInput(data.area);
          break;
        case 'playeraction':
          this.interactiveArea = new InteractivePlayeraction();
      }
    }
  }

  getHtmlOutput() {
    return this.interactiveArea.getHtmlOutput();
  }
}

export { InteractiveItem }
